import React from 'react';
import Link from 'next/link';
import { v4 as uuidv4 } from 'uuid';
import Nav from 'react-bootstrap/Nav';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import NavDropdown from 'react-bootstrap/NavDropdown';
import styles from '../styles/header/Navbar.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faChevronRight } from '@fortawesome/free-solid-svg-icons';

function NavbarLinks (props) {
    const {menuList, selected} = props;
    
    return (
        <Nav className="">
            {menuList.map( (item, i) =>

                item.mobileOnly ? '' :
                (item.type=='item' ?
                <Nav.Link as={Link} href={item.menuItem.link} key={uuidv4()} className={`pe-3 ${ selected == item.menuItem.title ? 'selected' : ''}`}>
                        {i==0 && <FontAwesomeIcon icon={item.icon} className="me-1 green" height="16" width="16" />}
                        {item.menuItem.title}
                    </Nav.Link>
                :
                <NavDropdown title={item.menuItem.title} className={`d-flex pe-3 ${selected==item.menuItem.title ? 'selected' : ''}`} key={uuidv4()} >
                    
                    <ul className={`${styles.dropItem} list-unstyled `}>
                        <li className={styles.topic}>Opțiuni</li>
                        { item.options.map ( (item, index) => 
                            <li className="" key={uuidv4()} >
                                {index!==0 && <NavDropdown.Divider  />}
                                <NavDropdown.Item as={Link} href={item.link} >
                                        <FontAwesomeIcon icon={faChevronRight} height="16" width="16" className="me-2 green"/>
                                        {item.name}
                                    </NavDropdown.Item>          
                            </li>
                        )}
                    </ul>
                </NavDropdown>)
                
            )}
        </Nav>
    );
}

export default NavbarLinks;